<template>
  <div id="app">
    <h1>{{ msg }}</h1>
    <h3 v-if="user">Hello {{ user.name }}</h3>
    <p v-if="loginFailed">Login unsuccessful</p>
  </div>
</template>

<script> 
import AuthService from  '@/components/services/auth.service';
import GraphService from '@/components/services/graph.service'; 

export default {
  name: 'msalSignIn',
  data() {
    return {
      msg: 'chess adminstrator will try to log you in',
      user: null,
      loginFailed: false
    }
  },
  created() {
    this.authService = new AuthService();
    this.graphService = new GraphService();
    this.login();
  },
  methods: {
/*    
    callAPI() {
      this.apiCallFailed = false;
      this.authService.getToken().then(
        token => {
          this.graphService.getUserInfo(token).then(
            data => {
              this.userInfo = data;
            },
            error => {
              console.error(error);
              this.apiCallFailed = true;
            }
          );
        },
        error => {
          console.error(error);
          this.apiCallFailed = true;
        }
      );
    },
*/
    logout() {
      this.authService.logout().then(
        this.$router.push("/")
      );
    },

    login() {
      this.loginFailed = false;
      this.authService.login().then(
        user => {
          //console.log ("User returned: " + JSON.stringify(user));
          if (user) {
            this.user = user;
            this.$CAUser.setMsalUser(user);            
          } else {
            this.loginFailed = true;
          }
        },
        () => {
          this.loginFailed = true;
        }
      );
    }
  }

}
</script>

